if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.isCartPage = document.body.classList.contains('template-cart');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (document.querySelector(".upsell-is-active")) {
          this.submitButton = document.querySelector(".upsell-is-active");
        } else {
          this.submitButton = this.querySelector('[type="submit"]');
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.submitButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        evt.submitter.setAttribute("aria-disabled", true);
        evt.submitter.classList.add("loading");
        evt.submitter.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        delete config.headers["Accept"];

        const formData = new FormData(this.form);

        const object = {};
        const properties = {};
        formData.forEach(function (value, key) {
          if (key === "quantity" || key === "id") {
            object[key] = parseInt(value, 10);
          } else if (key.startsWith("properties[") && key.endsWith("]")) {
            const propertyName = key.slice(11, -1);
            properties[propertyName] = value;
          } else {
            object[key] = value;
          }
        });

        if (Object.keys(properties).length > 0) {
          object.properties = properties;
        }
        if (!Number.isFinite(object.quantity) || object.quantity < 1) {
          object.quantity = 1;
        }

        this.applyBxgyOfferState(object);

        const formDataUpdate = {
          items: [object],
        };
        if (object.properties?._bxgy_offer_badge_label) {
          // PowerX checks campaign dates against this cart attribute. Refresh it
          // in the add request so a returning cart cannot keep an old date.
          formDataUpdate.attributes = {
            _powerx_datetime: String(Math.floor(Date.now() / 1000)),
          };
        }
        const quickAddModal = this.closest("quick-add-modal");

        /*
        if (document.querySelectorAll(".value-tree-product.active").length > 0) {
          document.querySelectorAll(".value-tree-product.active").forEach((input) => {
            const itemObject = {
              quantity: 1,
              id: input.dataset.id,
              properties: {
                'Free Gift': 'Yes'
              },
            };
            formDataUpdate.items.push(itemObject);
          });
        }
        */

        const sectionsToRender = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : quickAddModal
            ? ["cart-icon-bubble"]
            : [];

        if (sectionsToRender.length) {
          formData.append("sections", sectionsToRender);
          formData.append("sections_url", window.location.pathname);

          formDataUpdate["sections"] = sectionsToRender.join(",");
          formDataUpdate["sections_url"] = window.location.pathname;
          if (this.cart) this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(formDataUpdate);

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;

              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");

              evt.submitter.setAttribute("aria-disabled", true);
              evt.submitter.querySelector("span").classList.add("hidden");

              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }
            this.error = false;

            if (quickAddModal) {
              if (this.cart) {
                quickAddModal.hide(true);
                this.cart.renderContents(response);
              } else {
                this.updateCartIcon(response);
                quickAddModal.hide();
              }
            } else if (this.isCartPage) {
              window.location.reload();
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            evt.submitter.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      updateCartIcon(response) {
        const cartIcon = document.getElementById("cart-icon-bubble");
        const cartIconSection = response.sections?.["cart-icon-bubble"];
        if (!cartIcon || !cartIconSection) return;

        const parsedSection = new DOMParser().parseFromString(cartIconSection, "text/html");
        const updatedCount = parsedSection.querySelector(".cart-count-bubble");
        const currentCount = cartIcon.querySelector(".cart-count-bubble");
        if (updatedCount && currentCount) currentCount.replaceWith(updatedCount);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      applyBxgyOfferState(itemObject) {
        const isPrimaryBuyButtonForm = !!this.closest(".product-block--buy-buttons");
        if (!isPrimaryBuyButtonForm) return;

        const productInfo = this.closest("product-info");
        if (!productInfo) return;

        const bxgyOffers = productInfo.querySelectorAll("[data-bxgy-offer]");
        if (!bxgyOffers.length) return;

        let bxgyOffer = productInfo.querySelector(
          `[data-bxgy-offer][data-product-form-id="${this.form.id}"]`
        );
        if (!bxgyOffer && bxgyOffers.length === 1) {
          bxgyOffer = bxgyOffers[0];
        }
        if (!bxgyOffer) return;

        const bxgyOfferBadgeLabel = (bxgyOffer.dataset.offerBadgeLabel || "").trim();
        if (bxgyOfferBadgeLabel) {
          itemObject.properties = itemObject.properties || {};
          itemObject.properties._bxgy_offer_badge_label = bxgyOfferBadgeLabel;
        }

        const selectedOfferOption = bxgyOffer.querySelector(
          'input[name="bxgy_offer_option"]:checked'
        );
        const totalNumberOfProducts = parseInt(bxgyOffer.dataset.numberOfProducts, 10);
        if (!selectedOfferOption || !Number.isFinite(totalNumberOfProducts) || totalNumberOfProducts < 1) {
          return;
        }

        if (selectedOfferOption.value === "bundle") {
          itemObject.quantity = totalNumberOfProducts;
        }
      }
    }
  );
}
